export default "__VITE_ASSET__m$HKnI4s__"